// src/modules/Courier/pages/Route/ControlPanel/ControlPanel.jsx
import React from 'react';
import { useRouteStore } from '../useRouteStore';
import styles from './ControlPanel.module.css';

export default function ControlPanel({
  grouped,
  toggleGrouping,
  sortOrder,
  onSortAddress,
  allExpanded,
  toggleExpandAll,
}) {
  const setModalPage = useRouteStore(s => s.setModalPage);
  const receipts            = useRouteStore(s => s.routeData?.receipts) || [];
  const selectedReceiptId   = useRouteStore(s => s.selectedReceiptId);
  const setSelectedReceiptId = useRouteStore(s => s.setSelectedReceiptId)

  return (
    <div className={styles.container}>
      <button
        className={styles.button}
        onClick={toggleGrouping}
      >
        {grouped ? 'Убрать группировку' : 'Сгруппировать'}
      </button>

      <button
        className={styles.button}
        onClick={onSortAddress}
      >
        Сортировка: {{
    sequence:    'По порядку',
    addressAsc:  'Адрес ▲',
    addressDesc: 'Адрес ▼',
    id:          'ID',
  }[sortOrder]}
      </button>

      <button
        className={styles.button}
        onClick={() => setModalPage('order')}
      >
        <i className="bi bi-list-nested pe-1" />
        Задать порядок
      </button>

      <button
        className={styles.button}
        onClick={() => {
          // 1. Берём все “Открытые”
          const open = receipts
            .filter(r => r.status === 'Открыта')
            .slice();

          if (open.length === 0) return;

          // 2. Сортируем по возрастанию sequence_number
          open.sort((a, b) => (a.sequence_number || Infinity) - (b.sequence_number || Infinity));

          // 3. Всегда берём самую первую (самую маленькую)
          const firstOpenId = open[0].id;

          setSelectedReceiptId(firstOpenId);
          setModalPage('receipt');
        }}
      >
        Следующая квитанция
      </button>




    </div>
  );
}
